import RequestHandler from "./RequestHandler";

function LoggersAPI() {
    const baseLoggersAPI = "logger";

    async function listLoggers(
        userId,
        organizationId,
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${baseLoggersAPI}/list?skip=${skip}&take=${itemsPerPage}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, {
                ...filters,
                userId,
                organizationId,
            });
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function exportLoggers(userId, filters) {
        try {
            const result = await RequestHandler.post(
                `${baseLoggersAPI}/export`,
                {
                    ...filters,
                    userId,
                }
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listLoggers,
        exportLoggers,
    };
}

export default LoggersAPI();
